<template>
    <a-form :label-col="labelCol" :label-align="labelAlign" :layout="layout" :validate-on-rule-change="false"
        :model="formDataModel">
        <div class="form-widget-list">
            <draggable :list="widgetList" item-key="id" tag="transition-group" :component-data="{ name: 'fade' }"
                v-bind="{ group: 'dragGroup', ghostClass: 'ghost', animation: 300 }" handle=".drag-handler" @end="onDragEnd"
                @add="onDragAdd" @update="onDragUpdate" :move="checkMove">
                <template #item="{ element: widget, index }">
                    <div class="transition-group-el">
                        <component :is="getWidgetName(widget)" :widget="widget" :key="widget.id" :widgetList="widgetList"
                            :indexOfParentList="index" :isDesign="true" :formData="formDataModel">
                        </component>
                    </div>
                </template>
            </draggable>
        </div>
    </a-form>
</template>

<script setup>
import ContainerComponents from "./container/index.js";
import FieldComponents from "./form-item/index.js";
import { ref, toRefs, computed, inject, provide, defineExpose } from 'vue';

const props = defineProps({
    formJsonObj: Object,
    formDataModel: Object,
})
const { formJsonObj, formDataModel } = toRefs(props)
const widgetList = computed(() => formJsonObj.value.widgetList)
const instanceList = ref({})

const { updateSelectWidget } = inject("designer")
const labelCol = computed(() => { return { style: { width: (formJsonObj.value.formConfig.labelWidth || "80") + 'px' } } })
const labelAlign = computed(() => formJsonObj.value.formConfig.labelAlign || "left")
const layout = computed(() => formJsonObj.value.formConfig.layout || "horizontal")

const onDragAdd = (evt) => {
    const newIndex = evt.newIndex
    if (!!widgetList.value[newIndex]) {
        updateSelectWidget(widgetList.value[newIndex])
    }
}
const onDragEnd = (evt) => {
    // console.log(evt)
}
const onDragUpdate = () => { }
const checkMove = (evt) => {
    if (!!evt.draggedContext && !!evt.draggedContext.element) {
        let wgType = evt.draggedContext.element.type + ''
        if (!!evt.to) {
            if (wgType === 'slot') {
                return false
            }
        }
    }

    return true
}
const getWidgetName = (widget) => {
    let obj = { ...FieldComponents, ...ContainerComponents }
    return obj[widget.type + "-widget"]
}

const getInstanceList = () => {
    return instanceList.value
}
provide("instance", {
    getInstanceList,
});
const getInstance = (name) => {
    return instanceList[name]
}
const updateInstance = (oldName, newName) => {
    let instance = instanceList[oldName]
    instanceList[newName] = instance
    delete instanceList[oldName]
}
const destoryInstanceList = () => {
    instanceList.value = {}
}
defineExpose({ getInstance, updateInstance, destoryInstanceList })
</script>

<style scoped>
.ant-form{
    height: 100%;
}
.form-widget-list {
    height: 100%;
    padding: 5px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>